export const ASSET_TYPES = {
  audio: 'audio',
  pdf: 'pdf',
  video: 'video',
}
export const CLICK = 'click'
export const ENTER = 'Enter'
